import { LeadStatus } from "../../../types/onboarding";

const STYLES: Record<LeadStatus, { bg: string; fg: string; label: string }> = {
  insurer_review: { bg: "#E69138", fg: "#fff3cd", label: "Insurer review" },
  docs_pending: { bg: "#4285F4", fg: "#fff3cd", label: "Docs pending" },
  signature_pending: { bg: "#00FF00", fg: "#fff3cd", label: "Signature pending" },
  ops_review: { bg: "#B7B7B7", fg: "#fff3cd", label: "Ops review" },
  it_review: { bg: "#C27BA0", fg: "#fff3cd", label: "IT review" },
  csv_pending: { bg: "#e9ecef", fg: "#00347e", label: "CSV pending" },
  legalnote_pending: { bg: "#fde9c8", fg: "#a85700", label: "Legal note pending" },
  payment_validation_pending: { bg: "#e0f2f1", fg: "#0a6b6b", label: "Payment validation" },
  ready_to_send: { bg: "#cfe2ff", fg: "#084298", label: "Ready to send" },
  complete: { bg: "#B7E1CD", fg: "#fff3cd", label: "Complete" },
  canceled: { bg: "#DD4B39", fg: "#fff3cd", label: "Canceled" },
  claim: { bg: "#E8F0FE", fg: "#545453", label: "Claim" },
};

export default function StatusBadge({ status }: { status: LeadStatus }) {
  const s = STYLES[status] ?? { bg: "#e9ecef", fg: "#495057", label: status };
  return (
    <span
      style={{
        display: "inline-block",
        padding: "0.2rem 0.55rem",
        borderRadius: "999px",
        fontSize: ".72rem",
        fontWeight: 600,
        background: s.bg,
        color: s.fg,
        whiteSpace: "nowrap",
      }}
    >
      {s.label}
    </span>
  );
}
